import React from "react"
import styles from "./index.module.scss"

export const DisclaimerContent = () => (
  <div className={styles.container}>
    <p className={styles.kicker}>
      <b>Hoplon Investment Partners LLP – Disclaimer</b>
    </p>
    <h2 style={{ marginBottom: "20px" }}>
      United Kingdom and EU Jurisdictions
    </h2>
    <p>
      This Website relating to Hoplon Investment Partners LLP and information
      within is only intended for distribution in the United Kingdom and
      selected European jurisdictions. It does not constitute an offer, or the
      solicitation of an offer, in any jurisdiction in which such offer or
      solicitation is unlawful.
    </p>
    <p>
      It is the responsibility of any person outside of these jurisdictions
      wishing to make an application to invest to satisfy themselves as to full
      observance of the laws of any relevant territory in connection therewith,
      including obtaining any requisite governmental or other consents,
      observing any other formalities required to be observed in such territory
      and paying any issue, transfer or other taxes required to be paid in such
      territory.
    </p>
    <p>
      Potential investors in any service managed or advised by Hoplon Investment
      Partners LLP should consult their financial adviser before investing. All
      prospective investors should consider carefully whether an investment is
      suitable for them in the light of their personal circumstances and the
      financial resources available to them. Potential investors should also
      fully consider the available information together with the risk warnings.
    </p>
    <p>
      Neither Hoplon Investment Partners LLP nor any of its subsidiaries,
      directors, employees or other representatives will be liable for loss or
      damage arising out of or in connection with the use of this Website. This
      limitation of liability applies to all damages of any kind, including
      without limitation: compensatory; direct; indirect or consequential
      damages; loss of data; loss of income or profit; loss of or damages to
      property; and claims of third parties.
    </p>
    <h2 style={{ marginBottom: "20px" }}>
      SFDR entity level disclosures 
    </h2>
    <p>
    Financial market participant: Hoplon Investment Partners GP S.à.r.l. (the “AIFM”)
    </p>
    <h3>
      EU Sustainable Finance Disclosure Regulation 
    </h3>
    <p>
      The EU Sustainable Finance Disclosure Regulation (Regulation (EU) 2019/2088) (“SFDR”) sets out sustainability disclosure obligations for financial market participants, financial advisers and financial products. Under Articles 3 and 4 of the SFDR, as financial market participant, the AIFM is required to make the following disclosures. 
    </p>
    <h3>
      Integration of Sustainability Risks (Article 3 SFDR)
    </h3>
    <p>
      The AIFM has integrated sustainability risks into its investment decision-making process.
    </p>
    <p>
      A “sustainability risk” is defined in Article 2(22) of the SFDR as “an environmental, social or governance event or condition that, if it occurs, could cause an actual or potential material negative impact on the value of the investment”. 
    </p>
    <p>
      The impact of these risks varies depending on the industry, region, and asset type. The AIFM ensures that sustainability risks are part of its investment process and are considered through a comprehensive analysis. As such, the internal policies and procedures of the AIFM are designed to identify, monitor and manage these sustainability risks.
    </p>
    <p>
      This analysis uses both internal and external inputs to identify exposure to sustainability risks.
    </p>
    <p>
      The AIFM considers factors such as ownership structure, board membership, capital allocation, management incentives, labour relations and climate risks.
    </p>
    <p>
      Furthermore, the AIFM has enhanced its risk management framework to effectively integrate sustainability risks.
    </p>
    <p>
      While integrating sustainability risk into its investment approach, the AIFM consider these risks alongside all other risks relevant to the portfolios of the funds it manages. It takes a holistic view of the portfolio composition and the holding of specific investments from a risk perspective. If the level of risk, including sustainability risk, is deemed unacceptable, the AIFM will take steps to mitigate and manage that risk.
    </p>
    <p>
      When delegating the management of client portfolios and funds to third-parties, the AIFM considers and evaluates the application of sustainability risk policies by external managers as part of its initial and ongoing due diligence. 
    </p>
    <h3>
      No Consideration of Principal Adverse Impacts (PAIs) (Article 4 SFDR)
    </h3>
    <p>
      The AIFM is required to make a “comply or explain” decision on whether to consider the principal adverse impacts (“PAIs”) of investment decisions on sustainability factors.
    </p>
    <p>
      Following a thorough evaluation of the PAI framework and while supporting the policy objectives of the PAI regime to enhance transparency for clients, investors, and the market, the AIFM has decided not to consider the PAIs of investment decisions on sustainability factors for the time being.
    </p>
    <p>
      Indeed, the AIFM believes that the current availability and quality of the data are insufficient for a comprehensive assessment of the potential adverse impact on sustainability factors.
    </p>
    <p>
      Further, given its size, the AIFM considers it disproportionate to comply.
    </p>
    <p>
      The AIFM will review this approach with the principal adverse impact regime and will formally re-evaluate the decision at least annually.
    </p>
  </div>
)
